/* src/app/shared/components/search/search.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.search .visible-small-only {
  display: block;
}
@media screen and (min-width: 48rem) {
  .search .visible-small-only {
    display: none;
  }
}
.search .visible-medium-up {
  position: relative;
  display: none;
}
@media screen and (min-width: 48rem) {
  .search .visible-medium-up {
    display: block;
  }
}
.search :not(.search-overlay) .mat-mdc-form-field {
  transition: width 0.35s ease-in-out;
}
@media screen and (min-width: 48rem) {
  .search :not(.search-overlay) .mat-mdc-form-field.mat-focused {
    width: 40rem;
  }
}
.search .search-form .search-icon {
  cursor: pointer;
}
.search .search-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(20, 19, 0, 0.9);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.search .search-overlay .close-overlay {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.search .search-overlay .search-form {
  margin-top: 25%;
}
:host {
  align-self: center;
}
/*# sourceMappingURL=search.component.css.map */
